import { render, staticRenderFns } from "./BrandVoiceAnalizeTextForm.vue?vue&type=template&id=02c0164a"
import script from "./BrandVoiceAnalizeTextForm.vue?vue&type=script&lang=js"
export * from "./BrandVoiceAnalizeTextForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports